import resetIcon from "./../../../img/icons/Icon-left.svg";
import localization from "../../../data/config";
import { useDispatch, useSelector } from "react-redux";
import { resetAll, resetQuickFilters, updateDefaultParameters } from "../../../actions/filters";
import { track } from "../../../actions/dtm";
import * as HASH from "../../../constants/config/hash";
import * as EVENTS from "../../../constants/config/dtm";
import React, { useState } from "react";
import "./style.css";
import { setModalState, openModal, closeModal } from "../../../actions/modal";
import { extractPSTIdFromURL, setUrlParameter } from "../../../utilities/filters";
import { sortNewest } from "../../../utilities/arrays";
import { SET_PARTS } from "../../../constants/actions/parts";
import { updateWidth } from "../../../actions/table";

const ResetTable = () => {
  const parts = useSelector((state)=>state.parts)
  const dispatch = useDispatch();

  const originalDefaultParams = useSelector(
    (state) => state.filters.originalDefaultParams
  );
  const [dontAskAgain, setDontAskAgain] = useState(
    localStorage.getItem("dontAskAgainResetTablePreference") === "true"
  );
  const pstID = extractPSTIdFromURL();

  /**
   * @name resetFilterState
   * @function
   * @const
   * @description Function to reset the filter state of Table.
   */
  const resetFilterState = () => {

    if (localStorage.getItem(`defaultParams${pstID}`)) {
      dispatch(updateDefaultParameters(originalDefaultParams, true));
      localStorage.removeItem(`defaultParams${pstID}`);
    }
    dispatch(resetAll());
    dispatch(resetQuickFilters(true));
    window.location = window.location.search + HASH.INITIATOR;
    dispatch(track(EVENTS.RESET_TABLE));
    dispatch({ type: SET_PARTS, payload: { parts: sortNewest(parts.allData) }});


    let sortSelectBox = document.querySelector("#sort-by");
    if(sortSelectBox){
      sortSelectBox.value = "Newest";
      sortSelectBox.dispatchEvent(new Event('change'));
   }
    let addMyAnalogBoxDiv = document.getElementsByClassName("add-my-analog-btn");
    if(addMyAnalogBoxDiv[0]){
      addMyAnalogBoxDiv[0].focus();
    }
    dispatch(closeModal());
  };

  /**
   * @name openModal
   * @function
   * @const
   * @description Function to open the AlertModal
   */
  const openLocalModal = () => {
    if (!dontAskAgain) {
      dispatch(
        setModalState({
          modalIcon: resetIcon,
          modalTitle: localization.confirmResetTableTitle,
          modalMessage: localization.confirmResetTableMessage,
          modalConfirmMessage: localization.confirmResetTable,
          haveActions: true,
          haveDontAskAgain: true,
          onConfirm: confirmResetTableFunc,
          onCancel: closeLocalModal,
        })
      );
      dispatch(openModal());
    } else resetFilterState();
  };

      /**
    * Handles the key press event, triggering an action if Enter key is pressed.
    *
    * @param {KeyboardEvent} event - The key press event.
    */
       const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
          openLocalModal();
        }
      };

  /**
   * @name closeModal
   * @function
   * @const
   * @description Function to close the AlertModal
   */
  const closeLocalModal = () => dispatch(closeModal());

  /**
   * @name confirmResetTableFunc
   * @function
   * @const
   * @description Function that executes when the user clieck on Confirm Button of AlertModal
   */
  const confirmResetTableFunc = (dontAskAgainChecked, confirmState) => {
       
    if (dontAskAgainChecked) {
      localStorage.setItem("dontAskAgainResetTablePreference", true); // Save the preference in local storage
      setDontAskAgain(dontAskAgainChecked);
    }
    resetFilterState();

   };

  return (
    <>
      <div className="reset" tabIndex={0} onKeyDown={handleKeyDown} onClick={openLocalModal} role="button" aria-label={`${localization.resetTable}. ${localization.opensModal}`}>
        <img src={resetIcon} className="reset-icon" alt="reset" tabIndex={-1}/>
        <p className="reset-title">{localization.resetTable}</p>
      </div>
    </>
  );
};

export default ResetTable;
